(function(window, angular){
	'use strict';
	
	angular
		.module('productPage', [
			'apiModule',
			'collapseModule',
			'coreModule',
			'duScroll',
			'minInvestmentAmountModule',
			'popoverModule',
			'portfolioAllocationChartModule',
			'reitElementListingModule',
			'riskAdjustedReturnModule',
			'viewPlanModule'
		])
		.constant('DEFAULT_ORDER_AMOUNT_OPTIONS', [
			{ value: "1000", label: "$1,000"},
			{ value: "2000", label: "$2,000"},
			{ value: "5000", label: "$5,000"},
			{ value: "10000", label: "$10,000"},
			{ value: "25000", label: "$25,000"},
			{ value: "50000", label: "$50,000"},
			{ value: "0", label: "Other amount"}
		])
		.constant('OFUND_ORDER_AMOUNT_OPTIONS', [
			{ value: "25000", label: "$25,000"},
			{ value: "50000", label: "$50,000"},
			{ value: "100000", label: "$100,000"},
			{ value: "250000", label: "$250,000"},
			{ value: "500000", label: "$500,000"},
			{ value: "1000000", label: "$1,000,000"},
			{ value: "0", label: "Other amount"}
    ])
		.value('duScrollOffset', 50)
		.value('globalConfig', globalConfig);
})(window, window.angular);

